import styled from 'styled-components';

export const PageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 0;
`;

export const CardContainer = styled.div`
  width: 100%;
  max-width: 400px;
  background: ${({ theme }) => theme.colors.bgColor};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.metrics.radius.large};
  padding: 40px 32px;
`;

export const PageTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading};
  font-size: ${({ theme }) => theme.typography.sizes.xxl};
  color: ${({ theme }) => theme.colors.text.dark.very};
  text-align: center;
  margin-bottom: 32px;
`;

export const ForgotLink = styled.a`
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.primary.main};
  cursor: pointer;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.colors.primary.dark};
  }
`;

export const FooterText = styled.div`
  text-align: center;
  margin-top: 24px;
  font-size: ${({ theme }) => theme.typography.sizes.sm};
  color: ${({ theme }) => theme.colors.text.dark.little};
`;

export const RegisterLink = styled.span`
  color: ${({ theme }) => theme.colors.primary.main};
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;
